var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatHead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51001 13.89V9.28001H12.32V4.08001H16.07V0.320007H19.73V3.88H22.64V9.47001H25.44V13.89H8.51001Z",
    fill: "#C5E7F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.28 13.89V9.28001H46.09V4.08001H49.84V0.320007H53.5V3.88H56.41V9.47001H59.21V13.89H42.28Z",
    fill: "#C5E7F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6801 13.89V11.58H15.5801V8.98002H17.4601V7.11002H19.2901V8.89001H20.7401V11.68H22.1401V13.89H13.6801Z",
    fill: "#DC70E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.34 13.89V11.58H49.24V8.98002H51.12V7.11002H52.95V8.89001H54.4V11.68H55.8V13.89H47.34Z",
    fill: "#DC70E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.88 23.71V20.7H63.63V13.89H7.29002V20.7H3.98003V23.71H0.650024V62.41H3.98003V65.52H7.29002V69.06H10.63V72.62H61.24V70.13H64.1V65.52H67.88V62.41H71.21V23.71H67.88Z",
    fill: "#C5E7F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8 36.53H50.75V44.96H55.8V36.53Z",
    fill: "#0086AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9301 49.4H43.5601V51.6H40.6901V53.97H38.6901V51.69H35.9301V49.4Z",
    fill: "#DC70E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.33 58.99H35.76V61.56H38.33V58.99Z",
    fill: "#0086AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.91 56.41H38.34V58.98H40.91V56.41Z",
    fill: "#0086AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.48 58.99H40.91V61.56H43.48V58.99Z",
    fill: "#0086AF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.66 37.58H23.61V46.01H28.66V37.58Z",
    fill: "#0086AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatHead);
export default __webpack_public_path__ + "static/media/cat-head.6b4b6f6f0e9b1b022bb6fd5817d3dc1c.svg";
export { ForwardRef as ReactComponent };